import { Separator, Skeleton } from "@/components/ui";
import { Fragment } from "react";

export const WomensHealthSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 rounded transition-colors mt-1 px-3 py-2"
      data-testid="womens-health-skeleton"
    >
      {[...Array(5)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`womens-health-skeleton-${index}`}>
          <div className="flex flex-row gap-2">
            <Skeleton className="h-10 w-1/2" />
            <Skeleton className="h-10 w-1/2" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};
